import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const target = node.dataset.loadTarget;
  const targets = document.querySelectorAll<HTMLElement>(
    `[data-load="${target}"]`
  );

  targets.forEach((element) => {
    const event = element.dataset.event || 'click';

    element.addEventListener(event, load, { passive: true });
  });
});
